import {
  accessibilityColors,
  desktopWidth,
  extraDesktopWidthMax,
  greyThemeDark1,
  greyThemeLight,
  greyThemeLighter,
  mediumDesktopExactWidth,
  navy900,
  textColor,
  themeColor,
  themeColorBlue,
  themeColorHoverBlue,
  white,
} from '@edulastic/colors'
import { Card, FlexContainer } from '@edulastic/common'
import { Affix, Input, Pagination, Modal, Select } from 'antd'
import { IconDownload } from '@edulastic/icons'
import styled from 'styled-components'
import { StyledDisclaimerText } from '../../../AIFeatures/common/styled'

export const ScrollBox = styled.div`
  padding-right: 30px;
  & > div {
    padding: 20px 0px 5px;
  }
`

export const SearchInput = styled(Input.Search)`
  .ant-input {
    background: ${greyThemeLighter};
    border: 1px solid ${greyThemeLight};
    border-radius: 2px;
    height: 40px;
    font-size: ${(props) => props.theme.smallLinkFontSize};

    @media (min-width: ${extraDesktopWidthMax}) {
      font-size: ${(props) => props.theme.smallFontSize};
    }
  }
  svg {
    fill: ${themeColor};
  }
`

export const CardBox = styled.div`
  width: ${({ isPlaylist }) => (isPlaylist ? '242px' : '255px')};
  @media (min-width: ${extraDesktopWidthMax}) {
    width: 264px;
  }
`

export const Container = styled.div`
  padding: 0px 0px 0px 20px;
  left: 0;
  right: 0;
  height: 100%;
  overflow: ${({ isZoomedView }) => (isZoomedView ? 'scroll' : 'auto')};
  ${({ isZoomedView }) =>
    isZoomedView ? 'max-height: calc(100vh - 62px);' : ''}

  .ant-input-suffix {
    font-size: 15px;
    svg {
      fill: ${themeColor};
    }
  }

  .scrollbar-container {
    height: ${(props) =>
      `calc(100vh - ${
        props.theme.HeaderHeight.xs +
        60 +
        67 +
        (props.showStatusFilter ? 76 : 0)
      }px)`};

    ::-webkit-scrollbar {
      display: none;
    }

    @media (min-width: ${mediumDesktopExactWidth}) {
      height: ${(props) =>
        `calc(100vh - ${
          props.theme.HeaderHeight.md +
          60 +
          67 +
          (props.showStatusFilter ? 76 : 0)
        }px)`};
    }
    @media (min-width: ${extraDesktopWidthMax}) {
      height: ${(props) =>
        `calc(100vh - ${
          props.theme.HeaderHeight.xl +
          60 +
          67 +
          (props.showStatusFilter ? 76 : 0)
        }px)`};
    }
  }

  @media (max-width: ${desktopWidth}) {
    padding: 20px;
  }
`

export const ScrollbarWrapper = styled.div`
  display: ${({ isShowFilter }) => (isShowFilter ? 'none' : 'block')};
`

export const Filter = styled.div`
  width: ${(props) => (props.isShowFilter ? '20px' : '250px')};
  z-index: 0;

  @media (max-width: ${desktopWidth}) {
    display: none;
  }
`

export const CardContainer = styled(Card)`
  box-shadow: none;
  border-radius: 0px;
  .ant-card-body {
    padding: 0px;
  }
`

export const MobileFilter = styled.div`
  height: 50px;
  margin-bottom: 15px;
  display: none;

  @media (max-width: ${desktopWidth}) {
    display: flex;
    .ant-input-search {
      margin-right: 10px;
    }
  }
`

export const Main = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  background: white;
  width: ${(props) =>
    props.isShowFilter ? 'calc(100% - 20px)' : 'calc(100% - 250px)'};
  overflow: hidden;
  height: ${(props) =>
    props.isZoomedView
      ? 'fit-content'
      : `calc(100vh - ${props.theme.HeaderHeight.xs}px)`};

  @media (min-width: ${mediumDesktopExactWidth}) {
    height: ${(props) => `calc(100vh - ${props.theme.HeaderHeight.md}px)`};
  }
  @media (min-width: ${extraDesktopWidthMax}) {
    height: ${(props) => `calc(100vh - ${props.theme.HeaderHeight.xl}px)`};
  }
  @media (max-width: ${desktopWidth}) {
    width: 100%;
  }
`

/** Toolbar rows above the scrollable list (filters, district bar, bulk-convert alert). */
export const MainTopStatic = styled.div`
  flex-shrink: 0;
`

/**
 * Fills remaining viewport height so list + pagination scroll inside instead of
 * being clipped when MainTopStatic grows (e.g. BulkConvertStatusBar on Created by me).
 * Zoomed (narrow) layout uses fit-content Main — let this block size naturally.
 */
export const MainScrollBody = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;

  ${(p) =>
    p.$isZoomedView &&
    `
    flex: 0 1 auto;
    min-height: auto;
  `}
`

export const FilterButton = styled.div`
  flex: 1;
  height: 50px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.07);
  border-radius: 3px;

  .ant-btn {
    height: 50px;
    border-radius: 3px;
    width: 100%;

    span {
      font-size: 11px;
      font-weight: 600;
      color: ${textColor};
    }
  }
`

export const SearchModalContainer = styled.div`
  width: 100%;
`

export const MobileFilterModal = styled(Modal)`
  display: block;
  @media (min-width: ${desktopWidth}) {
    display: block;
  }
`

export const AffixWrapper = styled(Affix)`
  position: fixed;
  width: 250px;
  top: ${(props) =>
    props.theme.HeaderHeight.xs +
    (props.isBannerShown ? props.theme.BannerHeight : 0)}px;
  padding: 0px 0px 20px;

  @media (min-width: ${mediumDesktopExactWidth}) {
    top: ${(props) =>
      props.theme.HeaderHeight.md +
      (props.isBannerShown ? props.theme.BannerHeight : 0)}px;
  }
  @media (min-width: ${extraDesktopWidthMax}) {
    top: ${(props) =>
      props.theme.HeaderHeight.xl +
      (props.isBannerShown ? props.theme.BannerHeight : 0)}px;
  }
`

export const PaginationWrapper = styled(Pagination)`
  padding: ${(props) => (props.type === 'tile' ? '20px 0' : '24px 32px')};
  padding-right: 55px;
  text-align: right;
  .ant-pagination-item-ellipsis {
    color: ${greyThemeDark1} !important;
  }
`

export const StyleChangeWrapper = styled.div`
  margin-right: 15px;
  width: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  svg {
    cursor: pointer;
  }
`

export const StyledCountText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 10px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
`

export const ItemsMenu = styled(FlexContainer)`
  align-items: center;
  justify-content: space-between;
  padding: 22px 30px;

  @media screen and (max-width: ${desktopWidth}) {
    padding: 15px;
  }
`

export const PaginationInfo = styled.div`
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  white-space: nowrap;
  span:first-child {
    background: ${accessibilityColors.labels.grey.bg};
    padding: 2px 25px;
    border-radius: 15px;
    color: ${accessibilityColors.labels.grey.text};
    margin-right: 5px;
  }
`

export const FiltersWrapper = styled.div`
  display: flex;
  justify-self: center;
  margin-right: auto;
  margin-left: 10px;
  justify-content: flex-start;
  flex-wrap: wrap;
  .ant-tag {
    color: ${accessibilityColors.labels.grey.text};
    background: ${accessibilityColors.labels.grey.bg};
    padding: 2px 10px;
    border: none;
    font-weight: bold;
    border-radius: 6px;
    margin-bottom: 5px;
  }
`

export const NoDataMessageContainer = styled.div`
  max-width: ${({ maxWidth }) => maxWidth || '210px'};
  text-align: center;
  font-size: 20px;
`

export const LoaderOverlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1002;
  background: rgba(0, 0, 0, 0.2);
`

export const StatusFilterContainer = styled(ItemsMenu)`
  width: max-content;
  gap: 0.5rem;
  margin-top: -2rem;
  fon-size: 12px;
  font-weight: 600;
`

/** Wrapper for bulk convert status bar on My Content. */
export const BulkConvertStatusBarWrapper = styled.div`
  margin: 0 32px 16px;
  text-align: center;

  .ant-alert {
    padding: 14px 16px;
  }
`

export const BulkConvertStatusBarPanel = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 20px;
  background: ${white};
  border: 1px solid ${greyThemeLight};
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  text-align: left;
`

export const BulkConvertStatusBarLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  min-width: 0;
  flex: 1;
`

export const BulkConvertStatusBarSummaryRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

/** Aligns with summary text (icon width + gap). */
export const BulkConvertStatusBarDisclaimer = styled(StyledDisclaimerText)`
  text-align: left;
  margin: 0;
`

export const BulkConvertStatusIconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: ${themeColor};

  svg {
    width: 10px;
    height: 10px;
  }
`

export const BulkConvertStatusMessage = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${navy900};
  line-height: 1.4;
`

export const BulkConvertStatusBarActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`

export const BulkConvertDownloadButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  margin: 0;
  border: 1px solid ${navy900};
  border-radius: 999px;
  background: ${white};
  font-size: 14px;
  font-weight: 600;
  color: ${navy900};
  cursor: pointer;
  white-space: nowrap;

  &:hover:not(:disabled) {
    border-color: ${themeColorBlue};
    color: ${themeColorBlue};
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`

export const BulkConvertDismissButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 4px;
  color: ${navy900};

  &:hover {
    background: ${greyThemeLight};
  }
`

export const PdlBulkToolbarTopRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 0;
  padding: 8px 0 12px;
`

/** Title + CSV row; stacks grade/subject row underneath when both live in this column. */
export const PdlBulkToolbarHeadingWrap = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;

  /* PdlBulkUploadTitle: title text + download button stay inline / wrap together */
  > span:first-of-type {
    align-self: flex-start;
    max-width: 100%;
    flex-wrap: wrap;
    row-gap: 8px;
    column-gap: 10px;
  }

  /* Direct filters row fills width below title */
  > div:last-of-type {
    width: 100%;
    align-self: stretch;
  }
`

/** Sort control (Recency / SortMenu) — pinned to the right of the PDL toolbar top row. */
export const PdlBulkToolbarSortWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-left: auto;
`

export const PdlBulkUploadTitle = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${navy900};
  display: inline-flex;
  align-items: center;
  gap: 10px;
`

export const PdlBulkCsvDownloadIcon = styled(IconDownload)`
  flex-shrink: 0;
  width: 16px;
  min-width: 16px;
  height: 16px;
  & > g > path {
    fill: ${themeColorBlue};
  }
`

export const PdlBulkCsvButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 6px;
  color: ${themeColorBlue};
  &:hover:not(:disabled) {
    background: transparent;
    color: ${themeColorHoverBlue};
    svg > g > path {
      fill: ${themeColorHoverBlue};
    }
  }
  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`

export const PdlBulkToolbarFiltersRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
`

/** Single-select style: dropdown trigger only, no underline / heavy border, no search box in dropdown. */
export const PdlBulkFilterSelect = styled(Select)`
  min-width: 140px;
  max-width: 180px;

  .ant-select-selection {
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    border-bottom: 1px solid ${navy900} !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    background: transparent;
  }

  .ant-select-selection:hover,
  &.ant-select-focused .ant-select-selection,
  &.ant-select-open .ant-select-selection {
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    border-bottom: 1px solid ${navy900} !important;
    box-shadow: none !important;
  }

  .ant-select-selection__rendered {
    line-height: 32px;
    font-weight: 600;
    color: ${navy900};
  }
`

export const SelectionBarRow = styled(FlexContainer)`
  align-items: center;
  justify-content: space-between;
  padding: 0 30px 16px;
  flex-wrap: wrap;
  gap: 12px;

  @media screen and (max-width: ${desktopWidth}) {
    padding: 12px 15px 16px;
  }
`

export const SelectAllLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  user-select: none;

  input {
    margin: 0;
  }

  /* Ant Design 3: disabled + checked keeps same filled look as checked; fix tick to white */
  .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${themeColor} !important;
    border-color: ${themeColor} !important;
  }

  .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {
    border-color: #fff !important;
  }
`
